module.exports = __webpack_public_path__ + "img/promotion_10.jpg";